import { Button, Icon, Modal, Typography } from "@/components/atoms";
import { Vehicle } from "@/redux/slices/vehicle/types";
import { clsx } from "@/utils";
import { useVisibleVehicleTypes } from "./VehicleTypeCell";

interface VehicleTypesModalProps {
  vehicle: Vehicle | null;
  onClose: () => void;
}

const VehicleTypesModalContent = ({ vehicle }: { vehicle: Vehicle }) => {
  // Active attachments only — mirrors the table cell that opened this modal.
  const types = useVisibleVehicleTypes(vehicle) ?? [];

  return (
    <div className="flex flex-col">
      {types.map((type, index) => (
        <div key={type.uuid} className={clsx("flex items-center gap-3 py-3", index > 0 && "border-t border-neutral-gray")}>
          <Icon name="Car" variant="Bold" size="sm" className="text-neutral-dark-gray" />
          <Typography variant="paragraph">{type.name}</Typography>
        </div>
      ))}
    </div>
  );
};

export const VehicleTypesModal = ({ vehicle, onClose }: VehicleTypesModalProps) => {

  return (
    <Modal
      open={!!vehicle}
      onClose={onClose}
      title="Vehicle Types"
      description={vehicle ? `${vehicle.model.make} ${vehicle.model.model} • ${vehicle.registrationNumber}` : ""}
      variant="web-small"
      renderButtons={() => (
        <Button variant="tertiary" size="md" onClick={onClose}>
          Close
        </Button>
      )}
    >
      {vehicle && <VehicleTypesModalContent vehicle={vehicle} />}
    </Modal>
  );
};
